import { combineReducers } from 'redux';

const defaultOutgoingCalls = {};
const outgoingCalls = (state = defaultOutgoingCalls, action) => {
  switch (action.type) {
    case 'OUTGOING_CALLS_FILTER_COMPANY_SUCCESS':
      return action.outgoingCallsFilterCompany;
    case 'OUTGOING_CALLS_BY_FILTER_SUCCESS':
      return action.outgoingCallsByFilter;
    default:
      return state;
  }
};

const defaultIncomingCalls = {};
const incomingCalls = (state = defaultIncomingCalls, action) => {
  switch (action.type) {
    case 'INCOMING_CALLS_FILTER_COMPANY_SUCCESS':
      return action.incomingCallsFilterCompany;
    case 'INCOMING_CALLS_BY_FILTER_SUCCESS':
      return action.incomingCallsByFilter;
    default:
      return state;
  }
};

export default combineReducers({
  outgoingCalls,
  incomingCalls,
});
